<!-- 游戏控制按钮 -->
<template>
  <div class="game-control-btn">
    <div
      class="control-btn pause-btn"
      :class="{ 'is-paused': status === 'pause' }"
      @click="togglePause"
    ></div>

    <div
      class="control-btn volume-btn"
      :class="{ 'is-muted': isMuted }"
      @click="toggleMute"
    ></div>
  </div>
</template>

<script>
import { EventBus } from "../index.vue";
import { mapState } from "vuex";

export default {
  name: "GameControlBtn",
  data() {
    return {};
  },
  computed: {
    ...mapState("keyboardGame", ["status", "isMuted"]),
  },
  methods: {
    togglePause() {
      EventBus.$emit("setPause", this.status === "pause" ? false : true);
    },
    toggleMute() {
      EventBus.$emit("mute", this.isMuted);
    },
  },
};
</script>

<style lang="less" scoped>
.game-control-btn {
  display: flex;
  padding: 5px 10px;
  background: #fff;
  border-radius: 30px;
  margin: 10px 24px 0 0;
}

.control-btn {
  margin-right: 10px;
  width: 40px;
  height: 40px;

  &:hover {
    transform: scale(1.05);
  }

  &:active {
    transform: scale(0.95);
  }
}
.control-btn:last-child {
  margin-right: 0;
}

.pause-btn {
  background-image: url("../../../assets/game/images/btn-game-pause.png");
  background-size: 100% 100%;
}
.pause-btn.is-paused {
  background-image: url("../../../assets/game/images/btn-game-paused.png");
  background-size: 100% 100%;
}

.volume-btn {
  background-image: url("../../../assets/game/images/btn-volume-pause.png");
  background-size: 100% 100%;
}
.volume-btn.is-muted {
  background-image: url("../../../assets/game/images/btn-volume-paused.png");
  background-size: 100% 100%;
}
</style>
